import type React from 'react';

import { OrdReferenceInput } from '@ragu-components/ord-components';
import { Resources } from '@ragu-components/ord-resources';
import { UserUpdateFields } from '@ragu-components/ord-types';
import { canAccessWithPermissions } from '@ratto-components/ra-rbac';
import { usePermissions } from 'react-admin';

/**
 * A component that renders a service classes input field for user management.
 * The input is only displayed if the user has permissions to list service classes.
 *
 * @returns A reference input component for service classes if user has permissions,
 * otherwise returns an empty fragment
 *
 * @example
 * ```tsx
 * <ServiceClassesInput />
 * ```
 */
export const ServiceClassesInput = (): React.ReactElement => {
  const { permissions } = usePermissions();
  const canShowServiceClasses = canAccessWithPermissions({
    permissions,
    action: 'list',
    resource: Resources.service_classes,
  });
  if (!canShowServiceClasses) return <></>;
  return <OrdReferenceInput source={UserUpdateFields.service_class} resource={Resources.service_classes} />;
};
